import { NavLink } from 'react-router';

import { useT } from '@/i18n/context';
import type { MessageKey } from '@/i18n/types';

const TABS: { to: string; label: MessageKey }[] = [
  { to: '/', label: 'nav.today' },
  { to: '/history', label: 'nav.history' },
  { to: '/calendar', label: 'nav.calendar' },
  { to: '/timelapse', label: 'nav.timelapse' },
  { to: '/settings', label: 'nav.settings' },
];

/**
 * Bottom navigation for the three signed-in screens.
 *
 * Fixed to the bottom and padded for the home indicator, since the app is meant
 * to be installed to a phone's home screen and used one-handed.
 */
export function AppNav() {
  const t = useT();

  return (
    <nav className="app-nav fixed inset-x-0 bottom-0 border-t border-current/10 pb-[env(safe-area-inset-bottom)]">
      <ul className="mx-auto flex max-w-md">
        {TABS.map((tab) => (
          <li key={tab.to} className="flex-1">
            <NavLink
              to={tab.to}
              end={tab.to === '/'}
              className={({ isActive }) =>
                `block px-4 py-4 text-center text-sm ${isActive ? 'font-medium' : 'opacity-50'}`
              }
            >
              {t(tab.label)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
